import React from 'react';
import { Modal, Button } from 'antd';

export default function ApproveInfoModal(props) {
  const { approveInfoModalVisible, setApproveInfoModalVisible, approveRemarkSaler, approveRemarkNoSaler } = props;

  return (
    <Modal
      visible={approveInfoModalVisible}
      width={428}
      title="白名单审核流程说明"
      onCancel={() => setApproveInfoModalVisible(false)}
      footer={[
        <div style={{ textAlign: 'center' }}>
          <Button
            type="primary"
            onClick={() => {
              setApproveInfoModalVisible(false);
            }}
          >
            我知道了
          </Button>
        </div>,
      ]}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'left',
        }}
      >
        <div>白名单提交申请后，请在“京东Me-流程中心”关注审核状态/进度;具体审核流程如下:</div>
        <AugitFlow approveRemarkSaler={approveRemarkSaler} approveRemarkNoSaler={approveRemarkNoSaler} />
      </div>
    </Modal>
  );
}

export function AugitFlow({ approveRemarkSaler, approveRemarkNoSaler }) {
  return (
    <>
      {approveRemarkNoSaler ? (
        <div style={{ marginTop: 12 }}>
          <div>
            <img style={{ width: '380px', marginTop: '12px' }} src={approveRemarkNoSaler}></img>
          </div>
        </div>
      ) : null}
      {approveRemarkSaler ? (
        <div style={{ marginTop: 12 }}>
          <div>
            <img style={{ width: '380px', marginTop: '12px' }} src={approveRemarkSaler}></img>
          </div>
        </div>
      ) : null}
    </>
  );
}
